import React from "react";

const FluxAccessError = ({ companyName }) => {
  return (
    <div className="flex flex-col items-center justify-center p-6 bg-gray-50 rounded-md border border-gray-200 shadow-sm">
      <div className="w-16 h-16 flex items-center justify-center rounded-full bg-red-100 mb-4">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-8 w-8 text-red-500"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
          />
        </svg>
      </div>
      <h3 className="text-lg font-semibold text-gray-800 mb-2">
        Access Restricted
      </h3>
      <p className="text-center text-gray-600 mb-4">
        {companyName ? (
          <>
            Your company <span className="font-medium">{companyName}</span>{" "}
            doesn't have access to Flux services.
          </>
        ) : (
          <>You don't have access to Flux services.</>
        )}
      </p>
      <p className="text-sm text-gray-500">
        Please contact your administrator or{" "}
        <a
          href="mailto:support@chanels.io"
          className="text-blue-500 hover:underline"
        >
          support@chanels.io
        </a>{" "}
        for assistance.
      </p>
    </div>
  );
};

export default FluxAccessError;
